import { Box } from '@mui/material'

export default function Logo() {
  return (
    <Box
      component="img"
      src="/vericast-logo.svg"
      alt="Vericast Events"
      sx={{
        height: 32,
        width: 'auto',
      }}
    />
  )
}
